import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-209" data-mp="3ksqgpam7bm8l">
      <div className="mx-auto w-full max-w-6xl" data-id="element-210" data-mp="3fycofh2u5v85">
        <Reveal data-id="element-211" data-mp="3b0ufhqotjg05">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-212" data-mp="3b144bay4nh49">
            What coaches <span className="text-cheer" data-id="element-213" data-mp="36zqzn46rtjyx">are saying</span>
          </h2>
          <p className="mt-4 text-center text-sm font-semibold text-navy/60" data-id="element-214" data-mp="31zmu297ei9nh">
            4.9/5 — based on 500+ verified coaches
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-215" data-mp="2x2mnzyajx6wd">
          {testimonials.map((testimonial, index) => <Reveal key={testimonial.name} delay={index % 3 * 0.05} className="h-full" data-id="element-216" data-mp="v9yhng2m23cd" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-card border border-navy/10 bg-blush p-6 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-217" data-mp="qalka1e45dvj">
                <div className="flex items-center gap-3" data-id="element-218" data-mp="h818trjkkmm2">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cheer font-display text-xs font-extrabold text-white" data-id="element-219" data-mp="m62o01dvk1s9">
                    {testimonial.initials}
                  </span>
                  <span className="flex items-center gap-0.5" aria-label="5 out of 5 stars" data-id="element-220" data-mp="c7dhf4rfi3rb">
                    {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-221" data-mp="14ur7ciwplz1x" />)}
                  </span>
                </div>
                <blockquote className="mt-5 text-sm leading-relaxed text-navy/80" data-id="element-222" data-mp="1iu917cov42i5">
                  “{testimonial.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-6" data-id="element-223" data-mp="1nnv5aggymy2c">
                  <span className="block text-sm font-bold text-navy" data-id="element-224" data-mp="1xgpkpdrp2u94">
                    {testimonial.name}
                  </span>
                  <span className="block text-xs text-navy/55" data-id="element-225" data-mp="1sgtdl5npampc">{testimonial.role}</span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}